import { createRouter, createWebHashHistory } from "vue-router";
import { useAuthStore } from '../stores/auth';

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("/src/views/Login.vue"),
    meta: { requiresGuest: true }
  },
  {
    path: "/register",
    name: "register",
    component: () => import("/src/views/Register.vue"),
    meta: { requiresGuest: true }
  },
  {
    path: "/",
    name: "home",
    component: () => import("/src/views/BoardView.vue"),
    meta: { requiresAuth: true },
    children: [
      {
        path: "task/:cardId/:taskId",
        name: "task",
        component: () => import("/src/views/TaskView.vue"),
      },
    ],
  },
  {
    path: "/teams",
    name: "teams",
    component: () => import("/src/views/TeamView.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/boards",
    name: "boards",
    component: () => import("/src/views/BoardSidebarView.vue"),
    meta: { requiresAuth: true }
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 路由守卫
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();
  
  // 验证token
  if (!authStore.user && localStorage.getItem('token')) {
    await authStore.verifyAuth();
  }
  
  if (to.meta.requiresAuth && !authStore.user) {
    next('/login');
  } else if (to.meta.requiresGuest && authStore.user) {
    next('/');
  } else {
    next();
  }
});

export default router;
